import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { TypographyProps } from './Typography.types';
import { TYPOGRAPHY_COMPONENT_MAP, VARIANT_CLASS_NAME_MAP } from './Typography.constants';

export const Typography = ({
  variant = 'label',
  children,
  disableEllipse = false,
  outlined,
  className,
  ...rest
}: TypographyProps) => {
  const Component = `${TYPOGRAPHY_COMPONENT_MAP[variant]}` as const;

  const baseClassName = 'block font-normal text-text-primary m-0 p-0';

  const ellipseClassName = disableEllipse ? '' : 'text-ellipsis overflow-hidden whitespace-nowrap';

  const outlinedClassName = outlined
    ? 'border border-solid border-current p-[3px] rounded-[4px]'
    : undefined;

  const flattenedClassName = flattenClassNames([
    baseClassName,
    VARIANT_CLASS_NAME_MAP[variant],
    ellipseClassName,
    outlinedClassName,
    className,
  ]);

  return (
    // @ts-expect-error
    <Component className={flattenedClassName} {...rest}>
      {children}
    </Component>
  );
};
